module.exports = __webpack_public_path__ + "static/img/3.5a69cce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/3.png
// module id = o6oe
// module chunks = 0